import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import clsx from "clsx";
import { Avatar, IconButton, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { mdiMagnify } from "@mdi/js";
import Icon from "@mdi/react";
import "./styles.scss";

// Some override style of google material components
const useStyles = makeStyles({
  wrapRowAvatar: {
    paddingBottom: "0 !important",
  },
  smallAvatar: { width: 25, height: 25 },
});

const renderAvatars = (props) => {
  const { images = [] } = props;
  let showImages = images;
  const imgNum = 3;
  const plusImage = images.length - imgNum;
  if (plusImage > 0) {
    showImages = images.slice(0, imgNum);
  }
  return (
    <div className="wrap-avatars">
      {showImages.map(({ avatar }, i) => (
        <Avatar
          key={i}
          className={clsx(`chatHeader--avatar${showImages.length}_${i + 1}`, {
            [`chatHeader--avatar${showImages.length}_${i + 1}_plus`]:
              plusImage > 0,
          })}
          src={avatar}
        />
      ))}
      {plusImage > 0 && (
        <Avatar className="chatHeader--avatar_plus">{`+${
          plusImage < 100 ? plusImage : 99
        }`}</Avatar>
      )}
    </div>
  );
};

const HeaderPart = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const members = useSelector(
    (state) => state.project.memberProject.data.membersAdded || []
  );

  function openSearch() {
    props.setShowSearch(true);
  }

  return (
    <div className="container-header">
      {renderAvatars({ styles: classes, images: members })}
      <div className="wrap-room-description">
        <Typography className="chatHeader--title">
          {t("LABEL_CHAT_TASK_THAO_LUAN")}
        </Typography>
        {/* <NavigatorMenu /> */}
      </div>
      {/* <abbr title={t("LABEL_CHAT_TASK_THEM_THANH_VIEN")}>
        <IconButton className="chatHeader--button" onClick={openAddModal}>
          <PersonAddIcon style={{ fontSize: "25px" }} />
        </IconButton>
      </abbr> */}
      <abbr title={t("LABEL_CHAT_TASK_TIM_KIEM")}>
        <IconButton className="chatHeader--button" onClick={openSearch}>
          <Icon path={mdiMagnify} size={1.2} className="job-detail-icon" />
        </IconButton>
      </abbr>
    </div>
  );
};
export default withRouter(HeaderPart);
